import { cacheConfig } from "app-config";
import type { ControlledTextFieldOptions } from "components/inputs/ControlledTextField";
import networkService from "./networkService";

const cacheName = cacheConfig.territoires.name;

/**
 * Récupère tous les territoires
 * @returns Liste des territoires
 */
async function getAll(): Promise<Array<string>> {
  const url = `/data/territoires.json`;
  const options: RequestInit = {
    method: "GET",
    mode: "cors",
  };
  const response = await networkService.fetchWithCacheFallback(url, options, cacheName);
  return (await response.json()) as Array<string>;
}

/**
 * Récupère tous les territoires sous la forme ControlledTextFieldOptions
 */
async function getAllTextFieldOptions(): Promise<ControlledTextFieldOptions> {
  const textTerritoires = await getAll();
  return textTerritoires.map((territoire) => ({
    active: true,
    label: territoire,
    value: territoire,
  }));
}

const territoireService = {
  getAll,
  getAllTextFieldOptions,
};
export default territoireService;
